import { render } from "./Navigation.vue?vue&type=template&id=0cf16edd&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=0cf16edd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf16edd"]])

export default __exports__